import { io } from "socket.io-client";
import {APIBASE_HOST, MEDIABASE_HOST, PROXIED_MEDIABASE_HOST, SOCKET_HOST, STRIPE_KEY} from './env'

export const APIBASE = APIBASE_HOST + '/plapi/v1/';
export const PL_APIBASE = APIBASE_HOST + '/plapi/v1/';
export const MEDIABASE = MEDIABASE_HOST + '/';
export const PROXIED_MEDIABASE = PROXIED_MEDIABASE_HOST + '/';

// export const SOCKET = socketIOClient(SOCKET_HOST);

export const LOCALSTORENAME = 'sessiondatat';

export const LOGINSTORENAME = 'userlogins';

export const DEFAULTHTMLPAGECONTENT = '<h1><strong class="ql-size-huge">WHAT IS A BLACK HOLE?</strong></h1><p>Black holes are extremely dense pockets of matter, objects of such incredible mass and miniscule volume that they drastically warp the fabric of space-time. Anything that passes too close, from a wandering star to a photon of light, gets captured. Most black holes are the condensed remnants of a massive star, the collapsed core that remains following an explosive supernova. However, the black hole family tree has several branches, from tiny structures on par with a human cell to enormous giants billions of times more massive than our sun.</p><p><strong style="color: rgb(249, 219, 69);" class="ql-size-large">Primordial black holes</strong></p><p>Formed from the condensation of raw materials in the early cosmos, primordial black holes emerged soon after the Big Bang. Most were extremely tiny, and while those with the lowest-mass have likely evaporated, primordial black holes with larger masses may still exist – though even those have remained undetected.</p><p><strong style="color: rgb(249, 219, 69);" class="ql-size-large">Stellar-mass black holes</strong></p><p>The most common black holes form as the result of a supernova, the catastrophic death of a massive star. Most stellar-mass black holes are roughly five to ten times more massive than our sun, but NSF\'s Laser Interferometer Gravitational-Wave Observatory (LIGO) has detected several with masses up to 100 times that of our sun.</p><p><strong style="color: rgb(249, 219, 69);" class="ql-size-large">Intermediate-mass black holes</strong></p><p>In the mass range between stellar-mass and supermassive blackholes – that is hundreds to hundreds-of-thousands of solar masses – are intermediate-mass black holes. Astronomers have spotted evidence for a handful of candidates, but none have been conclusively detected. Theorists believe there are three scenarios for their formation: They could be primordial black holes, they might have formed in environments dense with stars, or they formed from mergers of stellar-mass black holes.</p><p><strong style="color: rgb(249, 219, 69);" class="ql-size-large">Supermassive black holes</strong></p><p>Supermassive black holes have masses ranging from millions to billions of solar masses and appear to be in the center of almost all galaxies. An important area of modern astrophysics is determining how supermassive black holes came to be: Were they formed with such high masses, or did their mass build up over time? The NSF-funded Event Horizon Telescope (EHT) project is attempting to capture an image of a black hole, setting its sights on two supermassive black holes, one in the center of the galaxy Messier 87 and the other in our Milky Way.</p>'

export const PROFILEKEY = 'profile';

export const SUBSCRIPTIONKEY = 'subscription';

export const CURRENTLESSONATTEMPTKEY = 'currentlessonattempt'

export const TOKENKEY = 'token';

export const CURRENTLESSONKEY = 'currentlesson';

export const CURRENTDESIGNATION = 'currentdesignation';

export const CURRENTUSERID = 'currentuserid';

export const CURRENTUSERNAME = 'currentusername';
export const CURRENTUSEREMAIL = 'currentuseremail';
export const CURRENTUSERCODE = 'currentusercodex';

export const  CURRENTDAYKEY = 'currentcalendarday';

export const SOCKET = io(SOCKET_HOST, {autoConnect: true,
    reconnection: true,
});

SOCKET.on("connect", () => {
    sessionStorage.setItem("socketId", SOCKET.id || "");
});

SOCKET.on("customEmit", (data) => {
       sessionStorage.setItem("socketId", data.id || "");
});

 export const connectSocket = () => {
     SOCKET.connect();
     SOCKET.emit("customMsg", { evt: "init" });
};


/* eslint-disable */
export const initialState = {
    "entityMap": {
        "0": {
            "type": "IMAGE",
            "mutability": "IMMUTABLE",
            "data": {
                "src": "https://picsum.photos/id/474/350/250"
            }
        }
    },
    "blocks": [{
        "key": "9gm3s",
        "text": "You can have images in your text field. This is a very rudimentary example, but you can enhance the image plugin with resizing, focus or alignment plugins.",
        "type": "unstyled",
        "depth": 0,
        "inlineStyleRanges": [],
        "entityRanges": [],
        "data": {}
    }, {
        "key": "ov7r",
        "text": " ",
        "type": "atomic",
        "depth": 0,
        "inlineStyleRanges": [],
        "entityRanges": [{
            "offset": 0,
            "length": 1,
            "key": 0
        }],
        "data": {}
    }, {
        "key": "e23a8",
        "text": "Try typing text and adding styles or images",
        "type": "unstyled",
        "depth": 0,
        "inlineStyleRanges": [],
        "entityRanges": [],
        "data": {}
    }]
};
/* eslint-enable */


// WEBPACK FOOTER //
// ./src/common/constants.ts